import { render, staticRenderFns } from "./show-image.vue?vue&type=template&id=22c277b0&scoped=true&lang=html&"
import script from "./show-image.vue?vue&type=script&lang=js&"
export * from "./show-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c277b0",
  null
  
)

export default component.exports